
// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from '@/integrations/supabase/types';
import { authStorage, getRememberMePreference } from '@/utils/authStorage';

const SUPABASE_URL = "https://akdhsybpxfexhkzsteih.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImFrZGhzeWJweGZleGhrenN0ZWloIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjU4NzA5ODYsImV4cCI6MjA4MTIzMDk4Nn0.BKR1ip_FcOGehgBgXLT2yaIxO3xmnbyFG6O-sWK5bR0";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: authStorage,
    autoRefreshToken: true, // Keep enabled but storage type controls persistence
    persistSession: true, // Keep enabled but storage type controls actual persistence
    detectSessionInUrl: true,
  }
});

/**
 * Helper to reinitialize auth storage when remember me preference changes
 * This ensures existing sessions are moved between localStorage/sessionStorage
 */
export const refreshAuthStorage = async () => {
  try {
    const { data: { session } } = await supabase.auth.getSession();
    
    if (session) {
      // Force re-save the session to the correct storage
      await supabase.auth.setSession(session);
    }
  } catch (error) {
    console.error('Error refreshing auth storage:', error);
  }
};
